import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { ProfileService } from '../profile.service';
import { GeneralService } from '../../../shared/services/general.service';

@Component({
  selector: 'app-edit-address-dialog',
  templateUrl: './edit-address-dialog.component.html',
  styleUrls: ['./edit-address-dialog.component.scss']
})
export class EditAddressDialogComponent implements OnInit {
  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();
  name: string;
  username: string;
  address: string;
  location: string;
  city: string;
  postal: string;
  editAddressform: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EditAddressDialogComponent>,
    private profileService: ProfileService,
    // private subscriberService: SubscriberService,
    private generalService: GeneralService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      // console.log(data);
      this.name = data.name;
      this.address = data.address;
      this.city = data.district;
      this.location = data.city;
      this.postal = data.postal;
    }

    ngOnInit(): void {
      this.editAddressform = new FormGroup({
        name: new FormControl(this.name, Validators.nullValidator && Validators.required),
        city: new FormControl(this.location, Validators.nullValidator && Validators.required),
        address: new FormControl(this.address, Validators.nullValidator && Validators.required),
        location: new FormControl(this.city, Validators.nullValidator && Validators.required),
        postalCode: new FormControl(this.postal, Validators.nullValidator && Validators.required),
      });
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  editAddress(form: NgForm) {
    this.profileService.patchHouseInfo(form.value.name, form.value.address,
      form.value.location, form.value.city, form.value.postalCode).
    subscribe((res: Response) => {
      this.action.emit(true);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/profile/edit-address-dialog/edit-address-dialog.component.ts